import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { ADD_LOADED_CATEGORY_ID } from '../sampling-supplies/sampling-supplies.actions';
import { LOAD_STATUS_MESSAGE, SetStatusMessage, SetSamplingSuppliesAccordionExpanding, LoadStatusMessage } from './layout.actions';
import { Store } from '@ngrx/store';
import * as fromApp from '@app/store/app.reducers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StatusMessage } from '@app/store/layout/layout.model';
import { environment } from '@env/environment';

@Injectable()
export class LayoutSamplingSuppliesEffects {


    onLoadCategories = createEffect(() => this.actions$.pipe(
        ofType(ADD_LOADED_CATEGORY_ID),
        switchMap(() => [new SetSamplingSuppliesAccordionExpanding(false)])
    ));

    constructor(private actions$: Actions) {
    }
}

@Injectable()
export class LayoutEffects {


    onLoadStatusMessage = createEffect(() => this.actions$.pipe(
        ofType(LOAD_STATUS_MESSAGE),
        mergeMap(() => {
            const url = `${environment.restBaseURL}/status-message`;

            const headers = new HttpHeaders({
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            });

            return this.httpClient.get(url, {
                headers: headers
            });
        }),
        map((response: StatusMessage) => new SetStatusMessage(response))
    ));

    constructor(private actions$: Actions,
        private store: Store<fromApp.AppState>,
        private httpClient: HttpClient) {}
}
